let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4r2dB")).then(() => parcelRequire('lTRum'));